import React from 'react'
import { Tooltip, Row, Col } from 'react-bootstrap'
import { ActionTableButton, FadeButton } from '../../../../library/button'
import { sendSuccessNotification } from '../../../../universal/notifications/notifications'

import './style.scss'

const Index = () => {

    const writeClipboard = val => {
        navigator.clipboard.writeText(val)
        sendSuccessNotification("Verdien ble kopiert.")
    }

	return(
        <>
            <div className="new-template-details-container">
                <div className="upper-details-container">
                    <h3>Liste over variabler</h3>
                    <p>En liste over variabler du kan bruke, som vil automatisk bli erstattet med den riktige informasjonen hentet fra mottakeren dersom den er tilstede. Trykk på knappene under for å kopiere til utklippstavlen, eller skriv inn manuelt.</p>
                </div>
                <div className="all-variables-container">
                    <Row className="single-information-row">
                        <Col className="information-col my-auto text-left">
                            <label className="label-title">Fornavn</label>
                        </Col>
                        <Col className="information-col my-auto text-right">
                            <ActionTableButton onClick={() => writeClipboard("{{kontakt_fornavn}}")} size="sm" color="gray" title="{{kontakt_fornavn}}"/>
                        </Col>
                    </Row>
                    <Row className="single-information-row">
                        <Col className="information-col my-auto text-left">
                            <label className="label-title">Etternavn</label>
                        </Col>
                        <Col className="information-col my-auto text-right">
                            <ActionTableButton onClick={() => writeClipboard("{{kontakt_etternavn}}")} size="sm" color="gray" title="{{kontakt_etternavn}}"/>
                        </Col>
                    </Row>
                    <Row className="single-information-row">
                        <Col className="information-col my-auto text-left">
                            <label className="label-title">Bedriftsnavn</label>
                        </Col>
                        <Col className="information-col my-auto text-right">
                            <ActionTableButton onClick={() => writeClipboard("{{kontakt_bedriftsnavn}}")} size="sm" color="gray" title="{{kontakt_bedriftsnavn}}"/>
                        </Col>
                    </Row>
                    <Row className="single-information-row">
                        <Col className="information-col my-auto text-left">
                            <label className="label-title">Bedriftsrolle</label>
                        </Col>
                        <Col className="information-col my-auto text-right">
                            <ActionTableButton onClick={() => writeClipboard("{{kontakt_bedriftsrolle}}")} size="sm" color="gray" title="{{kontakt_bedriftsrolle}}"/>
                        </Col>
                    </Row>
                    <Row className="single-information-row">
                        <Col className="information-col my-auto text-left">
                            <label className="label-title">E-postaddresse</label>
                        </Col>
                        <Col className="information-col my-auto text-right">
                            <ActionTableButton onClick={() => writeClipboard("{{kontakt_epost}}")} size="sm" color="gray" title="{{kontakt_epost}}"/>
                        </Col>
                    </Row>
                    <Row className="single-information-row">
                        <Col className="information-col my-auto text-left">
                            <label className="label-title">Telefon</label>
                        </Col>
                        <Col className="information-col my-auto text-right">
                            <ActionTableButton onClick={() => writeClipboard("{{kontakt_telefon}}")} size="sm" color="gray" title="{{kontakt_telefon}}"/>
                        </Col>
                    </Row>
                    <Row className="single-information-row">
                        <Col className="information-col my-auto text-left">
                            <label className="label-title">Nettside</label>
                        </Col>
                        <Col className="information-col my-auto text-right">
                            <ActionTableButton onClick={() => writeClipboard("{{kontakt_nettside}}")} size="sm" color="gray" title="{{kontakt_nettside}}"/>
                        </Col>
                    </Row>
                    <Row className="single-information-row">
                        <Col className="information-col my-auto text-left">
                            <label className="label-title">Facebook</label>
                        </Col>
                        <Col className="information-col my-auto text-right">
                            <ActionTableButton onClick={() => writeClipboard("{{kontakt_facebook}}")} size="sm" color="gray" title="{{kontakt_facebook}}"/>
                        </Col>
                    </Row>
                    <Row className="single-information-row">
                        <Col className="information-col my-auto text-left">
                            <label className="label-title">Twitter</label>
                        </Col>
                        <Col className="information-col my-auto text-right">
                            <ActionTableButton onClick={() => writeClipboard("{{kontakt_twitter}}")} size="sm" color="gray" title="{{kontakt_twitter}}"/>
                        </Col>
                    </Row>
                    <Row className="single-information-row">
                        <Col className="information-col my-auto text-left">
                            <label className="label-title">By</label>
                        </Col>
                        <Col className="information-col my-auto text-right">
                            <ActionTableButton onClick={() => writeClipboard("{{kontakt_by}}")} size="sm" color="gray" title="{{kontakt_by}}"/>
                        </Col>
                    </Row>
                    <Row className="single-information-row">
                        <Col className="information-col my-auto text-left">
                            <label className="label-title">Gate</label>
                        </Col>
                        <Col className="information-col my-auto text-right">
                            <ActionTableButton onClick={() => writeClipboard("{{kontakt_gate}}")} size="sm" color="gray" title="{{kontakt_gate}}"/>
                        </Col>
                    </Row>
                    <Row className="single-information-row">
                        <Col className="information-col my-auto text-left">
                            <label className="label-title">Gatenummer</label>
                        </Col>
                        <Col className="information-col my-auto text-right">
                            <ActionTableButton onClick={() => writeClipboard("{{kontakt_gatenummer}}")} size="sm" color="gray" title="{{kontakt_gatenummer}}"/>
                        </Col>
                    </Row>
                    <Row className="single-information-row bottom">
                        <Col className="information-col my-auto text-left">
                            <label className="label-title">Land</label>
                        </Col>
                        <Col className="information-col my-auto text-right">
                            <ActionTableButton onClick={() => writeClipboard("{{kontakt_land}}")} size="sm" color="gray" title="{{kontakt_land}}"/>
                        </Col>
                    </Row>
                </div>
            </div>
            <Tooltip color="light"/>
        </>
	)
}

export default Index